export default __webpack_public_path__ + "static/5-86adeb82fbfa5ba6ff446db40ca51d65.png";